import { resolveRawMediaUrl } from './qiniuMedia.js';

/** 生成数据时与 type 同级的 way 字段映射 */
const BLOCK_WAY_MAP = {
	// 音频
	'audio-player': 'audio',
	'audio-library': 'audio',
	'audio-header': 'audio',
	'pay-audio-player': 'audio',
	'pay-audio-library': 'audio',
	'pay-audio-playlist': 'audio',
	// 视频
	'video-list': 'video',
	'video-row': 'video',
	'video-header': 'video',
	'pay-video-player': 'video',
	'pay-video-list': 'video',
	'pay-video-series': 'video',
	// 文件
	'file-header': 'file',
	'pay-file-unlock': 'file',
	'pay-file-list': 'file',
	'pay-file-collection': 'file',
	// 图片
	'image-grid': 'image',
	'image-card': 'image',
	'image-feature-card': 'image',
	'image-collage': 'image',
	'image-trio': 'image',
	'image-mosaic': 'image',
	'image-quad': 'image',
	'image-header': 'image',
	'pay-image-gallery': 'image',
	'pay-image-wall': 'image',
};

export function getBlockWay(type) {
	return BLOCK_WAY_MAP[type] || '';
}

/** 付费组件 pay=1，其余 pay=0（与 type 同级） */
export function getBlockPay(type) {
	return typeof type === 'string' && type.startsWith('pay-') ? 1 : 0;
}

export function serializeBlockForRender(block = {}) {
	const way = getBlockWay(block.type);
	const sanitized = sanitizeBlockMediaUrls(block);
	const result = {
		...sanitized,
		pay: getBlockPay(block.type),
	};
	if (way) {
		result.way = way;
	}
	return result;
}

function sanitizeMediaValue(value) {
	if (!value || typeof value !== 'object') return value;
	if (Array.isArray(value)) {
		return value.map(sanitizeMediaValue);
	}
	const hasMediaShape = ('url' in value || 'previewUrl' in value)
		&& ('id' in value || 'filename' in value || 'filesize' in value || 'filesize_byte' in value);
	if (hasMediaShape) {
		const rawUrl = resolveRawMediaUrl(value);
		if (rawUrl) {
			return { ...value, url: rawUrl, previewUrl: rawUrl };
		}
	}
	const next = {};
	Object.keys(value).forEach((key) => {
		next[key] = sanitizeMediaValue(value[key]);
	});
	return next;
}

function sanitizeBlockMediaUrls(block = {}) {
	return {
		...block,
		data: sanitizeMediaValue(block.data),
	};
}

export function serializeBlocksForRender(blocks = []) {
	return blocks.map(serializeBlockForRender);
}
